import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { useLanguage } from '../../../Context/LanguageContext';
import { getColor, lightTheme, darkTheme } from '../../../Styles/theme';

import lodash from 'lodash';

import FetchModule from '../../Share/Network/FetchModule';
import LessonBox from './LessonBox';

import EmptyValueLogo from '../../../image/EmptyValueLogo.png';
import { ReactComponent as PlusSvgIcon } from '../../../image/Plus.svg';
import BlackPencelIcon from '../../../image/BlackPencel.svg';
import BlackExitIcon from '../../../image/BlackExit.svg';
import MemberShipInfoBox from './MemberShipInfoBox';
import LessonEditBox from './LessonEditBox';
import MemberShipEditBox from './MemberShipEditBox';
import DeleteConfirmModal from './Modal/DeleteConfirmModal';
import CustomAlert from '../../Share/Normal/CustomAlert';
import CategoryBox from './CategoryBox';
import CategoryEditBox from './CategoryEditBox';

export default function NewMemberShipAndClassView() {
  const history = useHistory();
  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [isConfirm, setIsConfirm] = useState(false);
  const [isViewCustomAlert, setIsViewCustomAlert] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [rendering, setRendering] = useState(false);

  const [myStore, setMyStore] = useState({
    storeId: 0,
    storeName: '',
    storeLogo: '',
  })
  const [followStores, setFollowStores] = useState([]);
  const [memberShipData, setMemberShipData] = useState([]);
  const [useMemberShipData, setUseMemberShipData] = useState([]);
  const [memberShipBodyHeight, setMemberShipBodyHeight] = useState(0);
  const [lessonData, setLessonData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  const [isProcessing, setIsProcessing] = useState(false);

  const [isClickedLessonEdit, setIsClickedLessonEdit] = useState(false);
  const [isClickedMemberShipEdit, setIsClickedMemberShipEdit] = useState(false);

  const [clickLessonData, setClickLessonData] = useState(undefined);
  const [clickEditLessonData, setClickEditLessonData] = useState(undefined);
  const [clickEditMemberShipData, setClickEditMemberShipData] = useState(undefined);

  // 수업 추가하기 클릭시 이미 클릭했던 수업 정보 담기 //
  const [tempClickLessonData, setTempClickLessonData] = useState(undefined);

  const [toBeDeletedDivision, setToBeDeletedDivision] = useState('None');
  const [toBeDeletedData, setToBeDeletedData] = useState(undefined);

  // 카테고리 움직임 //
  const [totalScrollY, setTotalScrollY] = useState(0);
  const [target, setTarget] = useState(undefined);
  const [targetStartY, setTargetStartY] = useState(0);
  const [targetEndY, setTargetEndY] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [clickDivision, setClickDivision] = useState(undefined);
  const [clickIndex, setClickIndex] = useState(undefined);
  const [changedIndex, setChangedIndex] = useState(undefined);
  const [emptyHeight, setEmptyHeight] = useState(0);
  const [isNotClick, setIsNotClick] = useState(false);
  const [isMoving, setIsMoving] = useState(false);
  // 카테고리 움직임 //

  // 카테고리 순서 변경중 // 
  const [isInProgress, setIsInProgress] = useState(false);
  // 카테고리 순서 변경중 // 

  const LessonWrapperRef = useRef();
  
  useEffect(() => {
    window.addEventListener("scroll", onScrollTotalWindow);
    return () => {
      window.removeEventListener("scroll", onScrollTotalWindow);
    };
  }, []);  

  // Init API Call //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');

        if (responseData.status === 200) {
          setMyStore(responseData.data.myStoreData);
          setFollowStores(responseData.data.followStores);
          setMemberShipData(responseData.data.memberShips);
          setCategoryData(responseData.data.categories);
          setLessonData(responseData.data.lessonInfos);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [rendering])

  // 수업 클릭시 회원권 내역 찾기 및 회원권 뷰 크기 계산 //
  useEffect(() => {
    if (clickLessonData === undefined) {
      return;
    }

    setIsClickedLessonEdit(false);

    let finalData = [];

    for (let i = 0; i < memberShipData.length; i++) {
      if (memberShipData[i].categoryId === clickLessonData.id) {
        finalData.push(memberShipData[i])
      }
    }
    setUseMemberShipData(finalData);

    if (finalData.length === 0) setMemberShipBodyHeight(97);
    else {
      let height = 97 + 21 + (50 * finalData.length);

      if (height > 472) setMemberShipBodyHeight(472);
      else setMemberShipBodyHeight(height);
    }
  }, [clickLessonData, memberShipData])

  // 수업 추가하기 클릭시 //
  function onClickAddLessonEdit() {
    setTempClickLessonData(clickLessonData);
    setClickLessonData(undefined);
    setClickEditLessonData(undefined);
    setIsClickedLessonEdit(true);
  }

  // 수업 추가하기 닫기 클릭시 //
  function onClickExitAddLessonEdit() {
    setClickLessonData(tempClickLessonData);
    setTempClickLessonData(undefined);
    setClickEditLessonData(undefined);
    setIsClickedLessonEdit(false);
  }

  // 수업 수정 클릭시 //
  function onClickEditLessonButton(data) {
    setClickEditLessonData(data);
    setTempClickLessonData(clickLessonData);
    setClickLessonData(undefined);
    setIsClickedLessonEdit(true);
  }

  // 회원권 추가하기 클릭시 //
  function onClickMemberShipEdit() {
    setClickEditMemberShipData(undefined);
    setIsClickedMemberShipEdit(true);
  }

  // 회원권 클릭시 ( 수정 겸용 ) //
  function onClickEditMemberShipButton(data) {
    setClickEditMemberShipData(data);
    setIsClickedMemberShipEdit(true);
  }

  // 회원권 추가하기 닫기 클릭시 //
  function onClickExitAddMemberShipEdit() {
    setClickEditMemberShipData(undefined);
    setIsClickedMemberShipEdit(false);
  }

  // 회원권 저장 클릭시 //
  function onSaveMemberShip(requestData) {
    if (isProcessing) {
      alert(t('settingMembership.savingInProgress'));
      return;
    }

    setIsProcessing(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('membership/save', 'POST', requestData);

        if (responseData.status === 200) {
          let memberShip = memberShipData.slice();

          let isChanged = false;

          for (let i = 0; i < memberShip.length; i++) {
            if (memberShip[i].id === responseData.data.id) {
              memberShip[i] = responseData.data;
              isChanged = true;
              break;
            }
          }

          if (!isChanged) memberShip.push(responseData.data);

          setMemberShipData(memberShip);
          onClickExitAddMemberShipEdit();
          setIsProcessing(false);

          return true;
        }
        else if (responseData.status === 201) {
          alert(t('settingMembership.duplicateName'));
          setIsProcessing(false);

          return false;
        }
      }
    )();
  }

  // 수업 저장 클릭시 //
  function onSaveLessonInfo(requestData) {
    if (isProcessing) {
      alert(t('settingMembership.savingInProgress'));
      return;
    }

    setIsProcessing(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('membership/category/save', 'POST', requestData);

        if (responseData.status === 200) {
          let category = categoryData.slice();

          let isChanged = false;

          for (let i = 0; i < category.length; i++) {
            if (category[i].id === responseData.data.id) {
              category[i] = responseData.data;
              isChanged = true;
              break;
            }
          }

          if (!isChanged) category.push(responseData.data);

          setCategoryData(category);
          onClickExitAddLessonEdit();
        }

        setIsProcessing(false);
      }
    )();
  }

  // 회원권 삭제 클릭시 //
  function onClickDeletedMemberShip(data) {
    setIsConfirm(true);
    setToBeDeletedDivision('MemberShip');
    setToBeDeletedData(data);
  }

  // 수업 삭제 클릭시 //
  function onClickDeletedLesson(data) {
    setIsConfirm(true);
    setToBeDeletedDivision("Category");
    setToBeDeletedData(data);
  }

  // 삭제 취소 클릭시
  function deleteExitButtonClick() {
    setToBeDeletedDivision('None');
    setToBeDeletedData(undefined);
    setIsConfirm(false);
  }

  // 삭제 확인 버튼 클릭시
  function deleteYesClick() {
    if (toBeDeletedDivision === 'Category') {
      let requestData = {
        categoryId: toBeDeletedData.id
      }
      
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('membership/category/delete', 'POST', requestData);

          if (responseData.status === 200) setRendering(!rendering);
          else if (responseData.status === 202) {
            setAlertText(t('settingMembership.linkedMembershipError'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    else if (toBeDeletedDivision === 'MemberShip') {
      let requestData = {
        memberShipId: toBeDeletedData.id
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('membership/delete/', 'POST', requestData);

          if (responseData.status === 200) setRendering(!rendering);
          else if (responseData.status === 203) {
            setAlertText(t('settingMembership.activeMembershipError'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 204) {
            setAlertText(t('settingMembership.deleteFailed'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    setIsConfirm(false);
  }


  // Movement Component 이동 클릭시 //
  function onMouseDown(e, clickTarget, idx) {
    // 좌클릭에만 반응하도록 //
    if (e.button === 0) {
      setTarget(clickTarget);
      setClickIndex(idx);
      setChangedIndex(idx);
    }
    // 우클릭일 경우 원상복구 // 
    else if (target !== undefined && e.button === 2) {
      clickTarget.style.top = 'auto';
      clickTarget.style.position = 'static';
      clickTarget.style.zIndex = 1;
      clickTarget.style.width = '463px';

      setTarget(undefined);
      setTargetStartY(0);
      setTargetEndY(0);
      setClickIndex(undefined);
      setChangedIndex(undefined);
    }
  }

  // 선택된 Movement Component 이동 //
  function onMouseMove(e) {
    if (target === undefined) return;

    if (isMoving) {
      setIsNotClick(true);
      setTargetStartY(e.clientY - (23 + 9));
      setTargetEndY(e.clientY - (23 + 9) + target.offsetHeight);
      
      target.style.top = ((e.clientY + totalScrollY) - (23 + 9)) + 'px';
    }
    else if (!target.contains(e.target)) {
      setEmptyHeight(target.offsetHeight);
      target.style.width = '463px';
      target.style.position = 'absolute';
      target.style.zIndex = 50;

      setIsMoving(true);
    }
  }

  // 선택된 Movement Component에서 Focus를 잃을경우 ( 마우스 클릭을 떼거나 컴포넌트 밖으로 나갈경우 ) //
  function onMouseUpAndMouseLeave(e) {
    if (target !== undefined) {
      let newList = []

      // List의 자리변경을 위한 임시변수 //
      let swap = undefined;

      // // 원래의 자신의 자리인경우 실행하지 않음 //
      if (changedIndex !== undefined && clickIndex !== changedIndex) {
        let requestData = {
          categoryId: categoryData[clickIndex].id,
          orderNum: changedIndex + 1
        }

        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postData('membership/category/change/order/', 'POST', requestData);
  
            if (responseData.status === 200) {
              setRendering(!rendering);
            }
          }
        )();

        newList = lodash.clone(categoryData);

        // 움직일 데이터 추출 //
        swap = newList[clickIndex];
        // 움직일 데이터 원본 삭제 //
        newList.splice(clickIndex, 1);
        // 움직인 자리에 데이터 삽입 //
        newList.splice(changedIndex, 0, swap);

        setCategoryData(newList);
      }

      target.style.top = 'auto';
      target.style.left = 'auto';
      target.style.position = 'static';
      target.style.zIndex = 1;
      target.style.width = '463px';

      setTarget(undefined);
      setTargetStartY(0);
      setTargetEndY(0);
      setClickDivision(undefined);
      setClickIndex(undefined);
      setChangedIndex(undefined);
      setIsMoving(false);
      setEmptyHeight(0);

      setTimeout(() => {
        setIsNotClick(false);
      }, 300)
    }
  }

  // 카테고리 목록 스크롤 이벤트 감지 //
  function onScrollCategoryBox(e) {
    setScrollY(e.target.scrollTop);
  }

  // 페이지 스크롤 이벤트 감지 //
  function onScrollTotalWindow() {
    setTotalScrollY(window.scrollY);
  }


  // 인덱스 변경 Up Down 버튼 클릭시 //
  function onClickChangeCategoryOrderIndex(division, index) {
    if (isInProgress) return;

    setIsInProgress(true);

    let changeIndex = division === 'UP' ? categoryData[index].orderNum - 1 : categoryData[index].orderNum + 1;

    let requestData = {
      categoryId: categoryData[index].id,
      orderNum: changeIndex
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('membership/category/change/order/', 'POST', requestData);

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsInProgress(false);
        }
        else setIsInProgress(false);
      }
    )();
  }

  // 인덱스 변경 Up Down 버튼 클릭시 //
  function onClickChangeMembershipOrderIndex(division, index) {
    if (isInProgress) return;

    setIsInProgress(true);

    let changeIndex = division === 'UP' ? useMemberShipData[index].orderNum - 1 : useMemberShipData[index].orderNum + 1;

    let requestData = {
      membershipId: useMemberShipData[index].id,
      orderNum: changeIndex
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('membership/change/order/', 'POST', requestData);

        if (responseData.status === 200) {
          // 순서 변경 응답에는 Transient 필드가 없으므로 orderNum만 머지 //
          const updatedOrderMap = {};

          for (const m of responseData.data.memberships) {
            updatedOrderMap[m.id] = m.orderNum;
          }

          setMemberShipData(prev => {
            const merged = prev.map(m =>
              updatedOrderMap[m.id] !== undefined
                ? { ...m, orderNum: updatedOrderMap[m.id] }
                : m
            );
            // orderNum 정렬: useMemberShipData가 categoryId 필터만 수행하므로 표시 순서 보장 위해 정렬 //
            return merged.sort((a, b) => a.orderNum - b.orderNum);
          });
          setIsInProgress(false);
        }
        else setIsInProgress(false);
      }
    )();
  }

  return (
    <TopLevelWrapper>
      {isViewCustomAlert && <CustomAlert text={alertText} closeFn={() => setIsViewCustomAlert(false)} />}
      {isConfirm && <DeleteConfirmModal title={toBeDeletedDivision === 'Category' ? t('settingMembership.deleteCategory') : t('settingMembership.deleteMembership')} itemName={toBeDeletedData.name + (toBeDeletedDivision === 'Category' ? t('settingMembership.categorySuffix') : t('settingMembership.membershipSuffix'))} clickNoFn={deleteExitButtonClick} clickYesFn={deleteYesClick} />}
      <InfoBoxWrapper>
        <LessonBoxTotalWrapper isClickedLessonEdit={isClickedLessonEdit}>
          {
            <LessonBoxInnerWrapper isClickedMemberShipEdit={isClickedMemberShipEdit}>
              <LessonBoxWrapper 
                ref={LessonWrapperRef}
                onMouseMove={onMouseMove} 
                onMouseUp={onMouseUpAndMouseLeave} 
                onMouseLeave={onMouseUpAndMouseLeave}
                onScroll={onScrollCategoryBox}>
                {
                  categoryData.map((data, index) => (
                    <CategoryBox
                      key={'MembershipCategories-' + index}
                      data={data}

                      // 움직임 //
                      index={index}
                      dataListLength={categoryData.length}
                      target={target}
                      targetStartY={targetStartY}
                      targetEndY={targetEndY}
                      emptyHeight={emptyHeight}
                      clickIndex={clickIndex}
                      changedIndex={changedIndex}
                      setChangedIndex={setChangedIndex}
                      clickDivision={clickDivision}
                      isNotClick={isNotClick}
                      setIsNotClick={setIsNotClick}
                      onMouseDown={onMouseDown}
                      onClickChangeIndex={onClickChangeCategoryOrderIndex}
                      // 움직임 //

                      setClickLessonData={setClickLessonData}
                      isClickedLessonEdit={isClickedLessonEdit}
                      onClickEditLessonButton={onClickEditLessonButton}
                      onClickDeletedLesson={onClickDeletedLesson} />
                  ))
                }
              </LessonBoxWrapper>
              <AddLessonButton onClick={onClickAddLessonEdit}>
                <TextWrapper>
                  <StyledPlusIcon style={{ color: theme.subText }} />
                  <Text fontFmaily='NotoSansKR-Medium' fontSize={14} cursor='pointer'>{t('settingMembership.addCategory')}</Text>
                </TextWrapper>
              </AddLessonButton>
            </LessonBoxInnerWrapper>
          }
          <MemberShipEditBoxClipWrapper isActive={isClickedMemberShipEdit}>
            <MemberShipEditBoxOffsetWrapper>
              <MemberShipEditBox
                myStore={myStore}
                followStores={followStores}
                lessonData={lessonData}
                clickLessonData={clickLessonData}
                clickEditMemberShipData={clickEditMemberShipData}
                isClickedMemberShipEdit={isClickedMemberShipEdit}
                onClickExitAddMemberShipEdit={onClickExitAddMemberShipEdit}
                onSaveMemberShip={onSaveMemberShip} />
            </MemberShipEditBoxOffsetWrapper>
          </MemberShipEditBoxClipWrapper>
        </LessonBoxTotalWrapper>
        <MemberShipBoxTotalWrapper>
          <EmptyMemberShipBoxWrapper isHiding={clickLessonData !== undefined || isClickedLessonEdit}>
            <EmptyLogoView src={EmptyValueLogo} />
          </EmptyMemberShipBoxWrapper>
          {
            clickLessonData !== undefined &&
              <MemberShipBoxWrapper isClickedMemberShipEdit={isClickedMemberShipEdit} $isDark={isDark}>
                <MemberShipBoxTitle backgroundColor={getColor(clickLessonData.color, isDark)}>
                  <Text fontFmaily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{clickLessonData.name}</Text>
                </MemberShipBoxTitle>
                <MemberShipBoxBody height={memberShipBodyHeight}>
                  <MemberShipScrollBox isExist={useMemberShipData.length > 0}>
                    {
                      useMemberShipData.map((data, index) => (
                        <MemberShipInfoBox
                          key={'MembershipView-' + index}
                          data={data}
                          index={index}
                          isClickedMemberShipEdit={isClickedMemberShipEdit}
                          onClickEditMemberShipButton={onClickEditMemberShipButton}
                          onClickDeletedMemberShip={onClickDeletedMemberShip}
                          onClickDeletedLesson={onClickDeletedLesson}
                          onClickChangeIndex={onClickChangeMembershipOrderIndex}/>
                      ))
                    }
                  </MemberShipScrollBox>
                  <AddMemberShipButton onClick={onClickMemberShipEdit}>
                    <TextWrapper>
                      <StyledPlusIcon style={{ color: theme.subText }} />
                      <Text fontFmaily='NotoSansKR-Medium' fontSize={14} cursor='pointer'>{t('settingMembership.addMembership')}</Text>
                    </TextWrapper>
                  </AddMemberShipButton>
                </MemberShipBoxBody>
              </MemberShipBoxWrapper>
          }
          <CategoryEditBox
            clickEditLessonData={clickEditLessonData}
            isClickedLessonEdit={isClickedLessonEdit}
            onClickExitAddLessonEdit={onClickExitAddLessonEdit}
            onSave={onSaveLessonInfo} />
        </MemberShipBoxTotalWrapper>
      </InfoBoxWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 30px;

  margin-bottom: 96px;

  transition: all 0.3s ease-in-out;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 9px;
`;

const LessonBoxTotalWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 510px;

  transition: all 0.3s ease-in-out;
`;

const MemberShipEditBoxClipWrapper = styled.div`
  position: absolute;
  left: -40px;
  top: -35px;

  padding: 20px;

  width: 510px;
  overflow: hidden;

  border-radius: 10px;

  padding-bottom: 50px;

  pointer-events: ${props => props.isActive ? 'auto' : 'none'};
`;

const MemberShipEditBoxOffsetWrapper = styled.div`
  margin-left: 510px;
`;

const LessonBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: -10px;

  z-index: ${props => props.isClickedMemberShipEdit ? `-3` : `1`};
  opacity: ${props => props.isClickedMemberShipEdit ? `0` : `1`};

  transition: all 0.3s ease-in-out;
`;

const LessonBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-left: 10px;
  padding-bottom: 10px;

  width: 510px;
  max-height: 512px;

  overflow-y: scroll;
  overflow-x: hidden;

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const AddLessonButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 15px;
  margin-left: 12px;

  width: 495px;
  height: 52px;

  color: ${props => props.theme.subText};

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: 0px 10px 10px rgba(0, 54, 71, 0.02);

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const MemberShipBoxTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  position: relative;

  padding: 3px;

  width: 495px;
  min-width: 495px;
  max-width: 495px;
  height: 585px;
`;

const MemberShipBoxWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  min-width: 495px;
  max-width: 495px;

  border-radius: 0px 0px 10px 10px;
  box-shadow: ${props => props.theme.shadowLarge};
  transition: all 0.3s ease-in-out;
`;

const EmptyMemberShipBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 495px;
  min-width: 495px;
  max-width: 495px;
  height: 585px;

  opacity: ${props => props.isHiding ? 0 : 1};
  transition: opacity 0.3s ease-in-out;
`;

const MemberShipBoxTitle = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 52px;

  border-radius: 12px 12px 0px 0px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;
`;

const MemberShipBoxBody = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  color: ${props => props.theme.subText};

  width: 100%;
  height: ${props => props.height}px;

  overflow: hidden;

  transition: all 0.3s ease-in-out;

  border-radius: 0px 0px 10px 10px;
  background-color: ${props => props.theme.subBackground};
`;

const MemberShipScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.isExist ? `31` : `0`}px;

  width: 459px;
  max-height: 344px;

  gap: 20px;

  overflow-y: scroll;
  overflow-x: hidden;

  transition: all 0.3s ease-in-out;

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const AddMemberShipButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  margin: 37px 0px 15px 0px;

  width: 442px;
  height: 45px;

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const EmptyLogoView = styled.img`
  width: 180px;
  height: 180px;

  margin-bottom: 20px;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 6px;
`;

const StyledPlusIcon = styled(PlusSvgIcon)`
  width: 20px;
  height: 20px;

  transition: color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;